<style scoped lang="scss">
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .tc,.table{
    margin-top: 20px!important;
  }
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 800px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
  .note{
    display: flex;
    align-items: flex-start;
  }
  .table{
    tr{
      td:first-child{
        background: #F6FAFD;
        font-size: 16px;
      }
    }
  }
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_13.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>16S/18S/ITS扩增子测序</h1>-->
<!--          <h2 class="mt10">16S / 18S / ITS amplicon sequencing（三代）</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>16S/18S/ITS扩增子测序</h1>
      <h2 class="mt10">16S / 18S / ITS Amplicon Sequencing（三代）</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;margin-top: 20px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">原核微生物的16S rRNA基因长度约为1500 bp，真核微生物18S rRNA基因长度为1500 ~ 2000 bp，而ITS区长度为400 ~ 900 bp。在以往的研究中，16S/18S/ITS扩增测序一般基于第二代高通量测序平台，读长较短，通常覆盖16S V3、V4区，18S V9区，而微生物基因突变位点并不是均匀分布的，基于单个可变区的测序分析有可能会高估或低估这些突变，进而影响微生物群落的分类，因此二代扩增子有可能会无法反映微生物群落的真实情况。</p>
      <p class="desc mt20">而PacBio三代测序可以获得平均15 ~ 20 kb的长读长，在CCS测序模式下，可以实现扩增子的多圈读取，在获得全长扩增子序列的同时，保证了序列的准确性，能够更加真实地反映微生物群落的组成情况。</p>
      <div class="c-title">项目建库测序流程</div>
      <div class="tc mt30"><img src="@/assets/images/amplicon_1.png"></div>
      <div class="note">
        <span>注：</span>
        <p>Polymerase Read：为PacBio下机的一条read的read Length<br>
          Subreads：插入片段每测一次，生成一条subreads<br>
          CCS Reads：来源于同一条polymerase read的subreads（大于1条）生成的一致性序列</p>
      </div>
      <div class="c-title">技术参数</div>
      <table class="table">
        <tr>
          <td style="width:350px;">参数</td>
          <td>微生物多样性测序</td>
        </tr>
        <tr>
          <td>技术平台</td>
          <td>PacBio测序</td>
        </tr>
        <tr>
          <td>DNA质检</td>
          <td>双链DNA浓度 > 20 ng/μL，总量 > 1 μg</td>
        </tr>
        <tr>
          <td>测序策略</td>
          <td>PacBio测序，CCS文库构建</td>
        </tr>
        <!-- <tr>
          <td>测序数据量</td>
          <td>平均5000条CCS reads，最低3000条CCS reads</td>
        </tr> -->
        <tr>
          <td>组装指标</td>
          <td>无</td>
        </tr>
        <tr>
          <td>项目周期</td>
          <td>40个工作日</td>
        </tr>
      </table>
      <div class="c-title">技术路线</div>
      <div class="tc"><img src="@/assets/images/amplicon_2.png"> </div>
      <div class="c-title">样本送样建议</div>
      <div class="tc"><img src="@/assets/images/amplicon_3.png"> </div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  inject: ['reload'],
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  created() {
    this.reload()
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/amplicon.vue